export enum ApplicationFormSchemaStepLogicGroupFields {
  FIELDS = 'fields',
  IS_ALLOW_EMPTY_GROUP = 'is_allow_empty_group',
}
